if (!customElements.get('products-carousel')) {
  class ProductsCarousel extends customElements.get('slider-default') {
    constructor() {
      super();

      this.slider = null;
      this.sliderEl = this.querySelector('[data-slider]');
      this.slides = Array.from(this.sliderEl.querySelectorAll('.swiper-slide'));

      this.toggleSlider();

      ['load', 'resize'].forEach((eventName) => {
        window.addEventListener(eventName, () => {
          this.toggleSlider();
        });
      });
    }

    toggleSlider() {
      const slidesWidth = this.slides.reduce((acc, slide) => {
        return (acc += slide.clientWidth);
      }, -30);
      const enableSlider = slidesWidth > this.sliderEl.clientWidth;

      if (enableSlider) {
        if (!this.slider) this.initSlider();

        return;
      }

      if (!this.slider) return;

      this.slider.destroy();
      this.slider = null;
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
}
